import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import { PrimaryButton } from "@common";
import locale from "@bonliva-crm/locale";
import { Paper, Grid, TextField } from "@material-ui/core";
import { useSnackbars } from "@hooks";
import {
  BookingProfile_Get,
  useSetBookingCallNumberMutation,
  useBookingCallNumberForm_GetCustomerLazyQuery
} from "@graphql";

type Props = {
  bookingId: string;
  hospitalId: string;
  callNumber: string;
};

export function BookingCallNumberForm(props: Props) {
  const { showSuccess, showError } = useSnackbars();

  const [initialCallNumber, setInitialCallNumber] = useState("");
  const [callNumber, setCallNumber] = useState("");

  const [submit, { loading }] = useSetBookingCallNumberMutation({
    refetchQueries: [BookingProfile_Get.OperationName],
    onCompleted: () => {
      showSuccess("Updated");
      setInitialCallNumber(callNumber);
    },
    onError: (err) => {
      showError(`${err}`);
    }
  });

  const [getCustomer, { data }] = useBookingCallNumberForm_GetCustomerLazyQuery({
    variables: {
      id: props.hospitalId
    }
  });

  useEffect(() => {
    setCallNumber(props.callNumber);
    setInitialCallNumber(props.callNumber);
    getCustomer();
  }, [props.hospitalId, props.callNumber, getCustomer]);

  const canSubmit = !loading && trim(callNumber) !== trim(initialCallNumber);

  const handleSubmit = () => {
    submit({
      variables: {
        bookingId: props.bookingId,
        callNumber: callNumber
      }
    });
  };

  const isCustomerFromRegionBleking = () => {
    return data?.customerById?.Parents?.some((x) => x.Name === "Region Blekinge");
  };

  if (!isCustomerFromRegionBleking()) {
    return null;
  }

  return (
    <Paper
      style={{
        padding: 16,
        marginTop: 8,
        height: 95,
        display: "flex",
        alignItems: "center"
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={10}>
          <TextField
            label={locale.CallNumberLabelForRegionBleking}
            value={callNumber}
            onChange={(e) => {
              setCallNumber(e.target.value);
            }}
            fullWidth
            multiline
            disabled={loading}
          />
        </Grid>
        <Grid item xs={2} style={{ display: "flex", alignItems: "center" }}>
          <PrimaryButton fullWidth disabled={!canSubmit} onClick={handleSubmit}>
            {locale.Save}
          </PrimaryButton>
        </Grid>
      </Grid>
    </Paper>
  );
}
